import * as actionTypes from "./actionTypes";
import { shopcategories } from "../../data"; 
import {firebase} from "../../firebase/index";
import {collections,documents} from "../../firebase/firestoreNameSpaces"
import { generateUniqueId, removeSpecialChars, sortArrayObjects } from "../utility";
// import {firebase} from "../../firebase/index";
// import {collections,constants,documents} from "../../firebase/firestoreNameSpaces"
// import {generateUniqueId,uploadImage,deleteFileFromUrl} from "../utility"
 
export const onFetchShopSubCategories = () => { 
  return async (dispatch) => {
   
    try{
      dispatch({
        type: actionTypes.SHOP_CONTROLS, 
        payload: { loading: true },
      });
      let db = firebase.firestore();
      db.collection(collections.K5METADATA).doc(documents.SHOP)
      .onSnapshot(snapshot=>{
          let subcategories = []
          let data = snapshot.data();
          if(data.subcategories){
              for(let sk in data.subcategories){
                  subcategories.push({name:data.subcategories[sk],id:sk})
              }
              
              data.subcategories =   sortArrayObjects (subcategories,"name");
          }else{
              data.subcategories = []
          }
         
          dispatch({
            type: actionTypes.SHOP_CONTROLS,
            payload: { shopSubCategories: data.subcategories, loading: false },
          });

      })

  }catch(error){
    dispatch({
      type: actionTypes.SHOP_CONTROLS, 
      payload: { loading: false },
    });
      return alert(error)
  }


  };
};
 
export const onPostShopSubCategories = (oldBrand, shopArray, newShopObj) => {
 
  return async (dispatch) => {
    
    try{
 
      dispatch({
        type: actionTypes.SHOP_CONTROLS,
        payload: { shopBtnLoading: true },
      });
  
      let subcategories = shopArray;
      let newsubcategory = newShopObj.name;
      //#####################
     
      if((subcategories.filter(scat=>removeSpecialChars(scat.name.toLowerCase().trim()) == removeSpecialChars(newsubcategory.toLowerCase().trim()) )).length){
        dispatch({
          type: actionTypes.SHOP_CONTROLS,
          payload: { shopBtnLoading: false },
        });
          return alert("Please choose different subcategory")
      }
      let db = firebase.firestore();
      let subcategoryId = generateUniqueId(10)+subcategories.length+1
      await db.collection(collections.K5METADATA).doc(documents.SHOP).set({subcategories:{[subcategoryId]:newsubcategory}},{merge:true})
      dispatch({
        type: actionTypes.SHOP_CONTROLS,
        payload: { shopBtnLoading: false },
      });
      return alert(newsubcategory+" Added Successfully")
  }catch(error){
    dispatch({
      type: actionTypes.SHOP_CONTROLS,
      payload: { shopBtnLoading: false },
    });
      return alert(error)
  }

  };
};

export const onEditShopSubCategories = (oldShopObj, shopArray, newShopObj) => {
  return async (dispatch) => {

    try{
      dispatch({
        type: actionTypes.SHOP_CONTROLS,
        payload: { shopBtnLoading: true },
      });
      let subcategories = shopArray;
      let subcategoryId = oldShopObj.id;
      let newsubcategory = newShopObj.name;
      //#################
      if((subcategories.filter(scat=>removeSpecialChars(scat.name.toLowerCase().trim()) == removeSpecialChars(newsubcategory.toLowerCase().trim()) )).length){
        dispatch({
          type: actionTypes.SHOP_CONTROLS,
          payload: { shopBtnLoading: false },
        });
          return alert("Please choose different subcategory")
      }
      let db = firebase.firestore();
      await db.collection(collections.K5METADATA).doc(documents.SHOP).set({subcategories:{[subcategoryId]:newsubcategory}},{merge:true});
      dispatch({
        type: actionTypes.SHOP_CONTROLS,
        payload: { shopBtnLoading: false },
      });
      return alert("Renamed Successfully")
  }catch(error){ 

    dispatch({
      type: actionTypes.SHOP_CONTROLS,
      payload: { shopBtnLoading: false },
    });

    return alert(error)
  }
    
  };
};

export const onDeleteShopSubCategories = (shopObj) => {
  return async (dispatch) => {
  
    try{
      dispatch({
        type: actionTypes.SHOP_CONTROLS,
        payload: { deleteBtnLoading: true },
      }); 
      
      let subcategoryId = shopObj.id;

      try{
        document.getElementById(`closeshopmodal${subcategoryId}`).click()
      }catch(error){

      }

      //##########
      let db = firebase.firestore();
     await db.collection(collections.K5METADATA).doc(documents.SHOP).set({subcategories:{[subcategoryId]:firebase.firestore.FieldValue.delete()}},{merge:true})
     dispatch({
      type: actionTypes.SHOP_CONTROLS,
      payload: { deleteBtnLoading: false },
    });
  return alert("Deleted Successfully")
  }catch(error){
    dispatch({
      type: actionTypes.SHOP_CONTROLS,
      payload: { deleteBtnLoading: false },
    });
      return alert(error)
  }
 
  };
};
